import { react2angular } from 'react2angular';
import ConsistHistoryView from './ConsistHistoryView';

angular.module('webtip.module')
  .component('consistHistory', react2angular(ConsistHistoryView,['searchBy'],[]));
